import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-gradient-to-b from-orange-50 to-white py-16 px-4" data-id="element-28">
      <div className="max-w-6xl mx-auto" data-id="element-29">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-30">
          <div className="order-2 md:order-1" data-id="element-31">
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-32">
              ¡MIS HIJOS SÍ HABLARÁN ESPAÑOL!
            </h1>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-33">
              La guía práctica, emocional y estratégica para que tus hijos
              vuelvan a hablar español contigo…
              <span className="font-semibold" data-id="element-34">
                {' '}
                sin peleas, sin regaños y sin obligarlos.
              </span>
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-35">
              <CTAButton data-id="element-36">Consigue la Guía Ahora</CTAButton>
            </div>
          </div>

          <div className="order-1 md:order-2" data-id="element-37">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oRbYwRRrmE32q3FSGhid51/ChatGPT_Image_27_nov_2025%2C_18_49_47.png" alt="¡Mis Hijos Sí Hablarán Español! - Plan de Acción para Papás Bilingües" className="w-full max-w-md mx-auto rounded-lg shadow-2xl" data-id="element-38" />
          </div>
        </div>

        <div className="mt-12 p-6 bg-amber-50 border-l-4 border-amber-500 rounded-r-lg" data-id="element-39">
          <p className="text-lg text-gray-800 italic" data-id="element-40">
            Si tus hijos prefieren la TV en inglés, si te responden en inglés
            aunque tú insistas en español, o si te duele pensar que un día no
            podrán hablar con sus abuelos…
            <span className="font-bold" data-id="element-41">
              {' '}
              esta puede ser la página más importante que leas hoy.
            </span>
          </p>
        </div>
      </div>
    </section>;
}